import {
  EmptyState,
  ListPage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@skylabs-digital/backoffice-kit';
import { Files } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { appsApi } from '../api/apps.api';
import { AppFilesTable } from '../components/apps/AppFilesTable';

/**
 * Los archivos siempre se miran por app: no hay listado global (el endpoint es
 * `/bo/apps/:appId/files` y una lista cruzada de apps no le sirve a nadie). La
 * app elegida vive en la URL (`/files?app=<id>`) para que sea linkeable desde el
 * detalle de app y sobreviva al refresh.
 */
export function FilesPage() {
  const { data: apps, loading } = appsApi.useList();
  const [params, setParams] = useSearchParams();
  const appId = params.get('app') ?? undefined;
  const app = apps?.find((a) => a.id === appId);

  const selectApp = (id: string) => {
    const next = new URLSearchParams(params);
    next.set('app', id);
    setParams(next, { replace: true });
  };

  return (
    <ListPage
      title="Files"
      description={
        app
          ? `Every file stored by ${app.name}: originals, their variants and pending uploads.`
          : 'Pick an app to browse its files.'
      }
      actions={
        <Select value={appId ?? ''} onValueChange={selectApp}>
          <SelectTrigger className="w-56" aria-label="App">
            <SelectValue placeholder={loading ? 'Loading apps…' : 'Choose an app'} />
          </SelectTrigger>
          <SelectContent>
            {(apps ?? []).map((a) => (
              <SelectItem key={a.id} value={a.id}>
                {a.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      }
    >
      {appId ? (
        // `key`: cambiar de app reinicia página, prefijo y estado de la tabla.
        <AppFilesTable key={appId} appId={appId} />
      ) : (
        <EmptyState
          icon={<Files className="h-8 w-8" />}
          title="No app selected"
          description="Files live under an app. Choose one above to see what it has stored."
        />
      )}
    </ListPage>
  );
}
